module.exports = __webpack_public_path__ + "static/media/PD_01.7d4ca600.jpg";